function extractUrlParams(url: string) {
  const params = {} as Record<string, string>
  url?.split(/([/=?])/).forEach(part => {
    const variablePrefix = '${params.'
    if (part.startsWith(variablePrefix) && part.endsWith('}')) {
      const key = part.slice(variablePrefix.length, -1)
      params[key] = ''
    }
  })
  return params
}
export default extractUrlParams
